import React, { createContext, useState, ReactNode } from "react";

interface ArsTrackingItem {
  ID: string;
  CUSTRECORD_ARS_TRACKING_NUMBER: string;
}

interface StartRetrunContextType {
  supplyTypeSelected: string;
  updateStartRetrunContextData: (newValue: string) => void;
  printLabel: boolean;
  arsTracking: ArsTrackingItem[];
  setArsTracking: React.Dispatch<React.SetStateAction<ArsTrackingItem[]>>;
}

// Create the context object with a fallback default value
const StartReturnContext = createContext<StartRetrunContextType>({
  supplyTypeSelected: "",
  updateStartRetrunContextData: () => {},
  printLabel: false,
  arsTracking:[],
  setArsTracking:  () => {}
});

interface MyProviderProps {
  children: ReactNode;
}

export const StartRetrunContextProvider: React.FC<MyProviderProps> = ({
  children,
}) => {
  const [supplyTypeSelected, setValue] = useState("");

  const [arsTracking, setArsTracking] = useState<ArsTrackingItem[]>([]);

  const updateStartRetrunContextData = (newValue: string) => setValue(newValue);

  const printLabel = supplyTypeSelected === "Print Labels";

  // Context object to provide
  const contextObject: StartRetrunContextType = {
    supplyTypeSelected,
    updateStartRetrunContextData,
    printLabel,
    arsTracking,
    setArsTracking
  };

  return (
    <StartReturnContext.Provider value={contextObject}>
      {children}
    </StartReturnContext.Provider>
  );
};

export { StartReturnContext };
